/* src/app/pages/project/map/repository/forest-cloud/forest-cloud-source.component.scss */
.fc-search {
  background-color: var(--card);
  color: var(--foreground);
  border: 1px solid var(--border);
  border-radius: 5px;
  padding: 0.35rem 0.75rem;
}
.fc-search::placeholder {
  color: color-mix(in srgb, var(--foreground) 50%, transparent);
}
.fc-search:focus {
  outline: none;
  border-color: var(--primary);
}
.fc-list {
  list-style: none;
  margin: 0;
  padding: 0;
  color: var(--foreground);
}
.fc-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  border-top: 1px solid var(--border);
}
.fc-item:first-child {
  border-top: none;
}
.fc-item-main {
  flex: 1;
  min-width: 0;
}
.fc-item-name {
  font-size: 0.875rem;
  font-weight: bold;
  overflow-wrap: anywhere;
}
.fc-item-meta {
  font-size: 0.75rem;
  color: color-mix(in srgb, var(--foreground) 60%, transparent);
}
.fc-item-blocked .fc-item-name {
  color: color-mix(in srgb, var(--foreground) 60%, transparent);
}
.fc-mono {
  font-family: monospace;
}
.fc-pick {
  background: var(--primary);
  color: var(--primary-foreground);
  border: none;
  border-radius: 0.5rem;
  padding: 0.25rem 0.75rem;
  font-weight: bold;
  white-space: nowrap;
}
.fc-pick:hover {
  opacity: 0.6;
}
.fc-pick:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.fc-page {
  border-radius: 5px;
  border: 1px solid var(--border);
  background-color: var(--secondary);
  color: var(--foreground);
  padding: 2px 8px;
}
.fc-page:hover:not(:disabled) {
  background-color: var(--secondary);
}
.fc-page:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.fc-imported {
  color: var(--accent-action);
}
.fc-pick .fc-spin {
  display: inline-block;
  width: 0.75rem;
  height: 0.75rem;
  margin-right: 0.35rem;
  vertical-align: -0.1rem;
  border: 2px solid var(--border);
  border-top-color: var(--border);
  border-radius: 50%;
  animation: fc-spin 0.8s linear infinite;
}
@keyframes fc-spin {
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=forest-cloud-source.component-O5TU5OED.css.map */
